import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M18.125 1.875a2 2 0 0 1 2 2v16.25a2 2 0 0 1-2 2H6.875a2 2 0 0 1-2-2V3.875a2 2 0 0 1 2-2h11.25zm0 1.5H6.875a.5.5 0 0 0-.5.5v16.25a.5.5 0 0 0 .5.5h11.25a.5.5 0 0 0 .5-.5V3.875a.5.5 0 0 0-.5-.5zM9.062 17.5l.117.006a1.063 1.063 0 1 1-.117-.006zm3.568 0l.116.006a1.063 1.063 0 1 1-.116-.006zm3.307 0l.117.006a1.063 1.063 0 1 1-.116-.006zm-6.874-3.125l.116.006a1.063 1.063 0 1 1-.117-.006zm3.567 0l.116.006a1.063 1.063 0 1 1-.116-.006zm3.307 0l.117.006a1.063 1.063 0 1 1-.116-.006zM9.064 11.25l.116.006a1.063 1.063 0 1 1-.117-.006zm3.567 0l.116.006a1.063 1.063 0 1 1-.116-.006zm3.307 0l.117.006a1.063 1.063 0 1 1-.116-.006zm.313-6.875c.76 0 1.375.616 1.375 1.375v2.5c0 .76-.616 1.375-1.375 1.375h-7.5c-.76 0-1.375-.616-1.375-1.375v-2.5c0-.76.616-1.375 1.375-1.375h7.5zm-.125 1.5h-7.25v2.25h7.25v-2.25z' />
  </svg>
);
